import { JSX } from 'react';
import { PageSection, PageSectionContent } from '@greystar/designsystem';
import { Property, PropertyImage, withBooleanFeatureFlag } from '@greystar/lib';
import { PropertyDetailsImageGalleryProps, PropertyImageCarousel } from '@greystar/ui';
import { GetStaticComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';

const PropertyDetailsImageGallery = (props: PropertyDetailsImageGalleryProps): JSX.Element => {
  const videos = props.sitecoreContext.property?.videos;
  const isPageEditing = props.sitecoreContext.pageEditing;
  const propertyId = props.sitecoreContext.property?.id;
  const propertyName = props.sitecoreContext.property?.name;
  const state = props.sitecoreContext.property.location?.state ?? '';
  const propertyLocation = props.sitecoreContext.property?.location?.city;
  const propertyUrl = props.sitecoreContext.property?.contact?.communityWebsiteUrl;

  if (!props.data?.images) {
    return <></>;
  }

  return (
    <PageSection
      bottomColour="beige"
      isLeftFlushed="true"
      isRightFlushed="true"
      isTopFlushed="true"
    >
      <PageSectionContent hasMaxWidth={false} className="pt-4">
        <PropertyImageCarousel
          images={props.data.images}
          isPageEditing={isPageEditing}
          videos={videos}
          propertyName={propertyName}
          propertyId={propertyId}
          state={state}
          propertyLocation={propertyLocation}
          propertyUrl={propertyUrl}
        />
      </PageSectionContent>
    </PageSection>
  );
};

export const getStaticProps: GetStaticComponentProps = async (
  rendering,
  layoutData
): Promise<PropertyDetailsImageGalleryProps> => {
  const props = rendering as unknown as PropertyDetailsImageGalleryProps;
  const property = layoutData.sitecore.context.property as Property;
  const propertyImages = [property.image, ...(property.imageGallery ?? [])].filter(
    Boolean
  ) as PropertyImage[];

  if (!propertyImages) {
    return {
      ...props,
      data: {
        images: [],
        notFound: true,
      },
      flagKey: rendering.componentName,
      isPageEditing: layoutData.sitecore.context.pageEditing,
    };
  }

  return {
    ...props,
    data: {
      images: propertyImages,
      notFound: false,
    },
    flagKey: rendering.componentName,
    isPageEditing: layoutData.sitecore.context.pageEditing,
  };
};

export default withBooleanFeatureFlag<PropertyDetailsImageGalleryProps>(
  PropertyDetailsImageGallery
);
